export default __webpack_public_path__ + "static/how-to-watch-recordings-light-mode-bc366d311519f5a418c4c2338938ceb2.mp4";